import { render, staticRenderFns } from "./ASCAArtIncLink.vue?vue&type=template&id=c10f05d2"
import script from "./ASCAArtIncLink.vue?vue&type=script&lang=ts"
export * from "./ASCAArtIncLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports